import React from 'react';
import { Col, Row } from 'react-bootstrap';


import NPPanel from '../../NPPanel';
//import DataTable from '../DataTable';
import OrderDataTable from '../OrderDataTable';

class OrderData extends React.Component {
  constructor(props) {
    super(props);
    this.state={};

    //  this.search = this.search.bind(this);
    //this.search();
  }

  
  // search() {
  //   let self=this;
  //   const { API_BASE_URL } = constants;
  //   const header = {
  //     'Authorization': 'Bearer ' + this.props.apiToken,
  //     'Accept': 'application/octet-stream'
  //   };
  //   axios.get(API_BASE_URL + 'Dashboard/GetOrderGraphData', { headers: header })
  //   .then(result => {
  //       self.setState({orderGraphData:result.data});
  //   }
  //   );
    //orderGraphData: { url: 'Dashboard/GetOrderGraphData' }

    //const searchString = this.searchInput.value || '';

    //this.props.reloadData({ orderData: { params: { searchString } } });
  //}

  render() {
    const { apiToken, ccr } = this.props;

    // const titleNode = <div>
    //   <div className="pull-right title-search">
    //     <Form inline onSubmit={(evt) => { evt.preventDefault(); this.search() }}>
    //       <FormGroup>
    //         <InputGroup>
    //           <FormControl bsSize="small"
    //                       type="text"
    //                       placeholder="Order information"
    //                       inputRef={input => { this.searchInput = input }}
    //                       onFocus={evt => { evt.target.select() }} />

    //           <InputGroup.Button>
    //             <Button bsStyle="info" bsSize="small">
    //               <FontAwesome name="search" className="bigger" onClick={this.search} />
    //             </Button>
    //           </InputGroup.Button>
    //         </InputGroup>
    //       </FormGroup>
    //     </Form>
    //   </div>
    // </div>;

    let orderInformationNode = <OrderDataTable apiToken={apiToken} ccr={ccr} setIsLoadingForCCRPicker={this.props.setIsLoadingForCCRPicker} />;
    
    return (<NPPanel>
      <Row>
        <Col sm={12}>
          { orderInformationNode }
        </Col>
      </Row>
    </NPPanel>) 
  }
}

export default OrderData;
// export default wrapWithApiData({
//   apiCalls: {
//     orderData: { url: 'Dashboard/GetOrderData' },
//     orderGraphData: { url: 'Dashboard/GetOrderGraphData' },
//   },
// }, OrderData);